module.exports = "<p>\r\n  awsop-lab13 works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab13/awsop-lab13.component.html
// module id = ./src/app/course/labs/awsop/awsop-lab13/awsop-lab13.component.html
// module chunks = main